export const getGlobalThis = () => {
  if (typeof globalThis !== "undefined") return globalThis;
  // eslint-disable-next-line no-restricted-globals
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  if (typeof this !== "undefined") return this;
  throw new Error("Unable to locate globalThis");
};

/**
 * @typedef {Object} ISessionContext
 * @property {Function} activateSession - A function to activate the session
 * @property {Function} deactivateSession - A function to deactivate the session
 * @property {Function} loadingSession - A function to recall the initialLoader
 */

/**
 * @typedef {Object} ICookieContext
 * @property {({name: string, value: string})=>void} setCookie - A function to activate the session
 * @property {({name: string})=>void} removeCookie - A function to deactivate the session
 */

/**
 * @typedef {Object} IStorageContext
 * @property {({name: string, value: string})=>void} setLocalStorageItem - A function to activate the session
 * @property {({name: string})=>void} removeLocalStorageItem - A function to activate the session
 * @property {()=>void} clearLocalStorage - A function to deactivate the session
 */

/**
 * @typedef {Object} IGlobalsResponse
 * @property {ISessionContext} globalSessionContext - An istance of globalSessionContext
 * @property {ICookieContext} globalCookieContext - An istance of globalCookieContext
 * @property {IStorageContext} globalStorageContext - An istance of globalStorageContext
 * @property {Function} globalDispatch - An istance of globalDispatch
 */

/**
 * It's used to retrieve an istance of globalThis
 * @throws {Error} - Throws an error when globals are not properly configured
 * @returns {IGlobalsResponse} - A list of variables
 */
export const getGlobals = () => {
  const {
    globalSessionContext,
    globalCookieContext,
    globalStorageContext,
    globalDispatch,
  } = getGlobalThis() || {};
  if (
    !globalSessionContext ||
    !globalCookieContext ||
    !globalStorageContext ||
    !globalDispatch
  )
    throw new Error(
      "globalSessionContext or globalCookieContext or globalStorageContext or globalDispatch not setted"
    );
  return {
    globalSessionContext,
    globalCookieContext,
    globalStorageContext,
    globalDispatch,
  };
};
